import { render, staticRenderFns } from "./WatermarkOverlay.vue?vue&type=template&id=2dae0db6&scoped=true"
import script from "./WatermarkOverlay.vue?vue&type=script&lang=js"
export * from "./WatermarkOverlay.vue?vue&type=script&lang=js"
import style0 from "./WatermarkOverlay.vue?vue&type=style&index=0&id=2dae0db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae0db6",
  null
  
)

export default component.exports